import type { PlaybackRate } from '../hooks/useAudioPlayer';

/**
 * 全てのPlaybackRate値を定義した配列。
 * PlaybackRate型に新しい値が追加された場合、この配列も更新が必要。
 * テストでこの配列を使用することで、型拡張時にテストが失敗する仕組みを実現。
 */
export const PLAYBACK_RATE_OPTIONS: readonly PlaybackRate[] = [1.0, 1.25, 1.5, 1.75, 2.0];

const formatPlaybackRate = (rate: PlaybackRate): string => {
  const hasQuarterDecimal = rate % 0.5 !== 0;
  return `x${rate.toFixed(hasQuarterDecimal ? 2 : 1)}`;
};

export default formatPlaybackRate;
